import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { getAddMedicationAdministeredSelector } from '../selectors'
import { setAddToTimeLine, setResponse } from '../store/addMedicationAdministered.actions'
import { AddMedicationAdministeredConstants } from '../store/addMedicationAdministered.constants'
import { IAddMedicationAdministeredState } from '../store/addMedicationAdministered.types'
import { addMedicationAdministeredItem } from '../../timeline/store/timeline.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* saveAddMedicationAdministered() {
  const medicationAdministeredStateWithDefaults: IAddMedicationAdministeredState = yield select(
    getAddMedicationAdministeredSelector
  )
  const medicationAdministeredState: IAddMedicationAdministeredState = {
    ...medicationAdministeredStateWithDefaults,
    medicationDefaults: null,
  }

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const { addMedicationAdministeredData } = medicationAdministeredState

    const newAddMedicationAdministeredData = addMedicationAdministeredData?.filter(
      (medication) =>
        (medication.medication !== null && medication.medication.name !== '') ||
        (medication.dose !== null && medication.dose !== '') ||
        medication.doseUnit !== null ||
        medication.doseUnitPNNV !== null ||
        medication.route !== null ||
        medication.routePNNV !== null ||
        medication.frequency !== null ||
        (medication.rate !== null && medication.rate !== '') ||
        (medication.concentration !== null && medication.concentration !== '') ||
        medication.response !== null ||
        medication.responsePNNV !== null ||
        medication.complications.length ||
        medication.lotNumber !== '' ||
        medication.witness1 !== '' ||
        medication.witness2 !== ''
    )

    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (pcrDoc.patient?.medicationAdministeredStateList && pcrDoc.patient?.medicationAdministeredStateList.length) {
      const index = pcrDoc.patient?.medicationAdministeredStateList?.findIndex(
        (mas) => mas.key === medicationAdministeredState.key
      )
      if (index !== -1) {
        pcrDoc.patient.medicationAdministeredStateList[index] = {
          ...medicationAdministeredState,
          addMedicationAdministeredData: newAddMedicationAdministeredData,
        }
      } else {
        pcrDoc.patient?.medicationAdministeredStateList.push({
          ...medicationAdministeredState,
          addMedicationAdministeredData: newAddMedicationAdministeredData,
        })
      }
    } else {
      pcrDoc.patient = {
        ...pcrDoc.patient,
        medicationAdministeredStateList: [
          { ...medicationAdministeredState, addMedicationAdministeredData: newAddMedicationAdministeredData },
        ],
      }
    }
    try {
      const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setAddToTimeLine(true))
      yield put(setResponse(response))
      yield put(addMedicationAdministeredItem())
    } catch (e) {
      yield put(throwPcrException(`saveAddMedicationAdministered() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveMedicationAdministeredSaga() {
  yield takeLatest(
    [
      AddMedicationAdministeredConstants.SAVE_MEDICATION_ADMINISTERED,
      AddMedicationAdministeredConstants.SET_DATE_TIME,
      AddMedicationAdministeredConstants.SET_DATE,
      AddMedicationAdministeredConstants.SET_TIME,
      AddMedicationAdministeredConstants.SET_ASSESSED_BY,
      AddMedicationAdministeredConstants.SET_PTA,
    ],
    performWithMutexHOG,
    saveAddMedicationAdministered
  )
}
